<template>
  <div>
    <selection-card :title="$t('construction_work.civil_engineering')">
      <template v-slot:icon>
        <tiefbau-icon class="mr-2" />
      </template>
      <v-autocomplete
        :attach="true"
        outlined
        dense
        :label="$t('construction_work.company_name')"
        clearable
        return-object
        :items="filteredCompanies"
        v-model.lazy="selectedCompany"
        :item-text="companyText"
        :error-messages="groundworkCompanyError"
        class="ml-2"
        item-value="company_name"
      >
        <template v-slot:no-data>
          <div
            class="pl-3"
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            {{ $t('construction_work.no_data_text') }}
          </div>
        </template>
      </v-autocomplete>
      <v-autocomplete
        v-if="selectedCompany"
        :attach="true"
        dense
        outlined
        color="#9B004B"
        :label="$t('construction_work.contact_person')"
        clearable
        :items="companyContactPersons"
        v-model.lazy="selectedContactPerson"
        :item-text="contactPersonText"
        item-value="name"
        class="ml-2"
        :error-messages="groundworkContactPersonError"
        return-object
      >
        <template v-slot:no-data>
          <div
            class="pl-3"
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            {{ $t('construction_work.no_data_text') }}
          </div>
        </template>
      </v-autocomplete>
      <div class="optional_date">
        <div>
          {{ $t('calendar_side_selection_component.groundwork_by_client') }}
        </div>
        <v-checkbox
          color="#9B004B"
          v-model="groundwork_by_client"
          @change="groundworkByClient"
        ></v-checkbox>
      </div>
      <div class="ml-3" v-if="groundwork_by_client === false">
        <date-time-component
          @save-hours-minutes="saveDate($event)"
          @save-dates="saveDate($event)"
          v-model="valueItem.construction_planned_date"
          :v="v.construction_planned_date"
        >
        </date-time-component>
      </div>
    </selection-card>
  </div>
</template>

<script>
import TiefbauIcon from '../../icons/TiefbauIcon';
import DateTimeComponent from './DateTimeComponent';
import SelectionCard from './SelectionCard';

export default {
  name: 'GroundworkComponent',
  components: {
    TiefbauIcon,
    SelectionCard,
    DateTimeComponent,
  },
  props: {
    companies: {
      type: Array,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valueItem: {},
      companyContactPersons: [],
      groundwork_by_client: false,
      filteredCompanies: [],
    };
  },
  created() {
    this.valueItem = { ...this.value };
  },
  mounted() {
    this.filterCompanyByRegionalTeam();
  },
  methods: {
    groundworkByClient() {
      this.$store.commit('setGroundWorkByClient', this.groundwork_by_client);
    },
    saveDate(object) {
      this.$store.commit('setGroundwork' + object.key, object.value);
    },
    contactPersonText(value) {
      return value.name + ', ' + value.function;
    },
    companyText(value) {
      return (
        value.company_name +
        ', ' +
        value.street +
        ' ' +
        value.street_number +
        ', ' +
        value.zip +
        ' ' +
        value.city
      );
    },
    filterCompanyByRegionalTeam() {
      this.filteredCompanies = [];
      const selectedRegionalTeam = this.selectedRegionalTeam;
      this.companies.forEach(async (company) => {
        const isContactPersonForRegionalTeam =
          await company.contact_persons.some(function (contactPerson) {
            return contactPerson.regions.includes(selectedRegionalTeam);
          });
        if (isContactPersonForRegionalTeam) {
          this.filteredCompanies.push(company);
        }
      });
    },
    filterPersonsByRegionalTeamAndCompanyType(contactPersons) {
      const selectedRegionalTeam = this.selectedRegionalTeam;
      return contactPersons.filter(function (el) {
        return el.regions.includes(selectedRegionalTeam) && el.groundwork;
      });
    },
    setContactPersonList() {
      const selectedCompanyObject = this.filteredCompanies.find(
        (company) => company.company_name === this.selectedCompany
      );
      if (selectedCompanyObject) {
        this.companyContactPersons =
          this.filterPersonsByRegionalTeamAndCompanyType(
            selectedCompanyObject.contact_persons
          );
      }
    },
  },
  watch: {
    selectedRegionalTeam(newVal) {
      if (newVal) {
        this.filterCompanyByRegionalTeam();
      }
    },
    companies() {
      this.filterCompanyByRegionalTeam();
    },
    filteredCompanies(newValue) {
      if (newValue && this.selectedCompany) {
        this.setContactPersonList();
      }
    },
  },
  computed: {
    selectedRegionalTeam() {
      return this.$store.getters.getRegionalTeamShort;
    },
    groundworkCompanyError() {
      const errors = [];
      if (!this.v.company_name.$dirty) return errors;
      !this.v.company_name.required && errors.push('Bitte Firma auswählen');
      return errors;
    },
    groundworkContactPersonError() {
      const errors = [];
      if (!this.v.contact_person.$dirty) return errors;
      !this.v.contact_person.required &&
        errors.push('Bitte Ansprechpartner auswählen');
      return errors;
    },
    selectedCompany: {
      get() {
        return this.valueItem.company_name;
      },
      set(newselectedTiefbau) {
        if (newselectedTiefbau) {
          this.valueItem.company_name = newselectedTiefbau.company_name;
          this.companyContactPersons =
            this.filterPersonsByRegionalTeamAndCompanyType(
              newselectedTiefbau.contact_persons
            );
          this.$store.commit('setTiefbau', newselectedTiefbau.company_name);
        } else {
          this.valueItem.company_name = null;
          this.$store.commit('setTiefbau', null);
        }
      },
    },
    selectedContactPerson: {
      get() {
        return this.valueItem.contact_person;
      },
      set(newtiefbauContactPerson) {
        const contactPersonName = newtiefbauContactPerson
          ? newtiefbauContactPerson.name
          : '';
        this.valueItem.contact_person = contactPersonName;
        this.$store.commit('setTiefbauContactPerson', contactPersonName);
      },
    },
  },
};
</script>

<style>
.optional_date {
  display: flex;
  flex-direction: row;
  margin-left: 11px;
  width: 600px;
}
</style>
